import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { FunctionComponent } from 'react';
import { connect, useDispatch } from 'react-redux';
import styles from '../../CommonStyles/CommonGraphStyles.module.css';
import { callBackReasonReportData, callBackReportData, feedbackReportData, interestedBudgetReportData, interestedLocationReportData, interestedProjectReportData, interestedPropertyStageReportData, interestedPropertyTypeReportData, lostReasonReportData, notInterestedReportData, setClearFilter, updateStage } from '../../Redux/actions';
import {
  apiCallDrilldown,
  apiContactsDrilldown,
  drillDownTableOrg,
  apiCallDrilldownSales
} from '../../Services/analytics';
import { changeDateForRoute } from '../../Services/contacts';
import { properFormat, sortAnalytics } from '../../Values/utils';
import * as ReactBootStrap from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import './IntBar.style.css';
import { themeColors } from '../../Components/theme';
import { CSVLink } from "react-csv";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

type props = {
  data: any;
  type:
  | 'project'
  | 'location'
  | 'budget'
  | 'stage'
  | 'lost_reason'
  | 'call_back_reason'
  | 'not_int_reason'
  | 'propertyType'
  | 'propertyStage'
  | 'callLogs';
  heading: string;
  usersList: any;
  checked: boolean;
  teamsData: any;
  style?: any;
  show?: boolean;
  contacts: any;
  filter: 'MTD' | 'YTD' | 'PM' | 'All' | 'CUSTOM' | 'T' | 'Y';
  organizationUsers: any;
  history: any;
  user: any;
  teamLeadUsers: any;
  branchUsers: any;
  taskFilter?: any;
  leadFilter?: any;
  callFilter?: any;
  source?: boolean;
  theme: any;
};

const IntBarTable: FunctionComponent<props> = ({
  data,
  heading,
  type,
  usersList,
  checked,
  teamsData,
  style,
  show,
  contacts,
  filter,
  organizationUsers,
  history,
  user,
  teamLeadUsers,
  branchUsers,
  taskFilter,
  leadFilter,
  callFilter,
  source,
  theme,
}) => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [sortTableData, setSortTableData] = useState<any[]>([]);
  const [header, setHeader] = useState<any[]>([]);
  const [sortData, setSort] = useState<any[]>([]);
  const [sortTable, setSortTable] = useState<boolean>(false);
  const [allContacts, setAllContacts] = useState<any[] | undefined>(undefined);

  useEffect(() => {
    let contact: any[] = [];
    Object.keys(contacts.data).forEach((key) => {
      contact = [...contact, ...contacts.data[key]];
    });
    setAllContacts(contact);
  }, [contacts.data]);

  useEffect(() => {
    const tempHeader: string[] = ['Associate', 'Total'];
    const tempData: any[] = [];
    if (type === 'callLogs') {
      Object.keys(data).forEach((key) => {
        const analytics = data[key].callLogAnalytics;
        let sum = 0;
        Object.keys(analytics).forEach((key) => {
          if (
            !tempHeader.includes(key) &&
            key !== 'Pending' &&
            key !== 'Completed'
          ) {
            tempHeader.push(key);
          }
        });
        Object.keys(analytics).forEach((key) => {
          if (key !== 'Pending' && key !== 'Completed') {
            sum += analytics[key];
          }
        });
        tempData.push({
          name: checked ? key : source ? key : usersList[key],
          uid: key,
          Total: sum,
          ...analytics,
          teamUids:[]
        });
        // console.log("tempDataaaaaaaaaaaaaaaaaaa",tempData)
      });
    } else {
      Object.keys(data).forEach((key) => {
        const analytics = data[key].leadAnalytics[type];
        let sum = 0;
        Object.keys(analytics).forEach((key) => {
          if (
            !tempHeader.includes(key) &&
            key !== 'Pending' &&
            key !== 'Completed'
          ) {
            tempHeader.push(key);
          }
        });
        Object.keys(analytics).forEach((key) => {
          if (key !== 'Pending' && key !== 'Completed') {
            sum += analytics[key];
          }
        });
        tempData.push({
          name: checked ? key : source ? key : usersList[key],
          uid: key,
          Total: sum,
          ...analytics,
          teamUids:[]
        });
        
        // console.log("keyyyyyyyyyyyyyyyyyyyyyyyyyyy222222222222",usersList)
        // console.log("checkeddddddddddddddddddddddddddddddddddd",checked)
      });
    }
    let teamTempData: any[] = [];
    if (checked) {
      tempData.forEach((user) => {
        const team = teamsData[user.name];
        let existing = teamTempData.filter((item) => item.name === team);
        if (existing.length !== 0) {
          Object.keys(user).forEach((key) => {
            if (key !== 'name') {
              if(key !== 'teamUids'){
                if (existing[0][key]) {
                  existing[0][key] += user[key];
                } else {
                  existing[0][key] = user[key];
                }
              }else{
                if (existing[0][key]) {
                  existing[0][key].push(user["uid"]);
                } 
                else {
                  existing[0][key] = [user["uid"]];
                }
              }
            }
          });
        } else {
          // teamTempData.push({ ...user, name: team,teamUids:[user.uid] });
          teamTempData.push({ ...user, name: team, teamUids:[user.uid] });
        }
      });
    }

    let gt: { [key: string]: any } = {};
    const finalData = checked ? teamTempData : source ? tempData : tempData;
    // console.log("tempDataaaaaaaaaaaaaaaaaaa222222222222222",finalData)
    finalData.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key !== 'name') {
          if (gt[key]) {
            gt[key] += item[key];
          } else {
            gt[key] = item[key];
          }
        }
      });
    });
    finalData.sort(sortAnalytics);
    finalData.unshift({ name: 'Grand Total', ...gt });
    if (type !== 'callLogs') {
      tempHeader.forEach((item) => {
        if (item === 'Other') {
          const i = tempHeader.indexOf('Other');
          tempHeader.splice(i, 1);
          tempHeader.push('Other');
        }
      });
    }

    if (type === 'stage') {
      tempHeader.forEach((item) => {
        setHeader([
          'Associate',
          'Total',
          'FRESH',
          'CALLBACK',
          'INTERESTED',
          'WON',
          'NOT INTERESTED',
          'LOST',
        ]);
      });
    } else {
      setHeader(tempHeader);
    }
    setTableData(finalData.filter((item) => item.name !== undefined));
    setSortTableData(finalData.filter((item) => item.name !== undefined));
    setSort(finalData.filter((item) => item.name !== undefined));
  }, [data, checked]);

  const sortFunction = (item: any) => {
    setSortTable(true)
    const grandTotalObj = tableData.filter((i: any) => i.name === "Grand Total");
    let sortData: any;
    switch (item) {
      case item:
         sortData = tableData?.filter((i: any) => i.name !== "Grand Total")?.sort((a:any, b:any) => {
          const valueA = a[item] || 0;
          const valueB = b[item] || 0;
          return valueA - valueB;
         })
        break;
      default:
        break;
    }
    setSort([...grandTotalObj, ...sortData]);
    
  }
  const handleSortTableData=(item:any)=>{
    setSortTable(false)
    const grandTotalObj = tableData.filter((i: any) => i.name === "Grand Total");
    let sortData: any;
    switch (item) {
      case item:
         sortData = tableData?.filter((i: any) => i.name !== "Grand Total")?.sort((a:any, b:any) => {
          const valueA = a[item] || 0;
          const valueB = b[item] || 0;
          return valueB - valueA;
         })
        break;
      default:
        break;
    }
    setSort([...grandTotalObj, ...sortData]);
  }
  useEffect(() => {
    setTableData(sortData);
  }, [sortData])

  
  const dispatcher = useDispatch();
  // when a user clicks on the table data which is not zero, it opens up a drill down page, the api data for which is stored in the local storage and the necessary call is made from that page
  const getDrillDownData = async (key: string, item: any) => {
    if (type === 'callLogs') {
      if(user.profile === "Sales"){
        const drillDownData = await apiCallDrilldownSales(
          filter,
          user.profile === "Sales" ? user.uid : item.name === 'Grand Total' ? user.uid : item.uid,
          key,
          taskFilter,
          leadFilter,
          callFilter,
          item.name === 'Grand Total' ? true : false,
          item.teamUids ? item.teamUids : [],
          item
        );
        const newDrollDown = {
          ...drillDownData,
          organizationid: user.organization_id
        }
        localStorage.setItem('callDrilldownData', JSON.stringify(newDrollDown));
        window.open('/callDrilldownData', '_blank');
      }else{
        const drillDownData = await apiCallDrilldown(
          filter,
          user.profile === "Sales" ? user.uid : item.name === 'Grand Total' ? user.uid : item.uid,
          key,
          taskFilter,
          leadFilter,
          callFilter,
          item.name === 'Grand Total' ? true : false,
          item.teamUids ? item.teamUids : []
        );
        const newDrollDown = {
          ...drillDownData,
          organizationid: user.organization_id
        }
        localStorage.setItem('callDrilldownData', JSON.stringify(newDrollDown));
        window.open('/callDrilldownData', '_blank');
      }
    } else {
      const typeData = type === 'lost_reason'
        ? 'LOST'
        : type === 'not_int_reason'
          ? 'NOT INTERESTED'
          : 'INTERESTED';
      const drillDownData = await apiContactsDrilldown(
        item.name === 'Grand Total' ? user.uid : item.uid,
        type === 'propertyStage'
          ? 'property_stage'
          : type === 'propertyType'
            ? 'property_type'
            : type,
        key,
        type === 'call_back_reason'
          ? 'CALLBACK'
          : typeData,
        filter,
        taskFilter,
        leadFilter,
        item.name === 'Grand Total' ? true : false,
        item.teamUids ? item.teamUids : []
      );
      if (item.name === 'Grand Total') {
        let newDrollDown 
        {checked===false? newDrollDown= {
          uid: user.uid,
          leadFilter: drillDownData.leadFilter,
          taskFilter: drillDownData.taskFilter,
          role: drillDownData.role,
          organizationid: user.organization_id,
          source: source
        }:newDrollDown= {
          uid: user.uid,
          leadFilter: drillDownData.leadFilter,
          taskFilter: drillDownData.taskFilter,
          role: drillDownData.role,
          organizationid: user.organization_id,
          source: source,
          team:item.name
        }}
        localStorage.setItem('drilldownData', JSON.stringify(newDrollDown));
        // console.log("newDrollDown11111111111111111111111111111111",newDrollDown)
        window.open('/drilldownData', '_blank');
      } else {
        let newDrollDown 
        {checked===false? newDrollDown= {
          ...drillDownData,
          organizationid: user.organization_id,
          source: source
        }:newDrollDown= {
          ...drillDownData,
          organizationid: user.organization_id,
          source: source,
          team:item.name
        }}
        localStorage.setItem('drilldownData', JSON.stringify(newDrollDown));
        // console.log("lopappa",newDrollDown)
        window.open('/drilldownData', '_blank');
      }
    }
  };

  const tableTextStyles = { color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  // console.log("tableDataaaaaaaaaaaaaaaaaaaaaaaaaa",type)

  useEffect(() => {
    if(type==="stage" ){
      // if(checked===true){
        const result= tableData.map((item:any) => {
          const stage: { stage: string; count: number }[] = [];
          for (const key in item) {
              if (key !== "name" && key !== "Total" && key !== "uid" && key !== "teamUids" && key !== "Grand Total") {
                  stage.push({
                      stage: key,
                      count: item[key] || 0
                  });
              }
          }
          return {
              stage,
              name: item.name,
              total: item.Total
          };
      });
      
      // maindata=result
      // }else{
      //   maindata=reportData
      // }
      dispatcher(feedbackReportData(result));}
      
    if(type==="call_back_reason" ){
        // if(checked===true){
          // console.log("tableData",tableData)
          const result= tableData.map((item:any) => {
            const call_back_reason: { call_back_reason: string; count: number }[] = [];
            for (const key in item) {
                if (key !== "name" && key !== "Total" && key !== "uid" && key !== "teamUids" && key !== "Grand Total") {
                  call_back_reason.push({
                      call_back_reason: key,
                        count: item[key] || 0
                    });
                }
            }
            return {
              call_back_reason,
                name: item.name,
                total: item.Total
            };
        });
        
        // maindata=result
        // }else{
        //   maindata=reportData
        // }
      dispatcher(callBackReasonReportData(result));}

    if(type==="budget" ){
          // if(checked===true){
            // console.log("tableData",tableData)
            const result= tableData.map((item:any) => {
              const budget: { budget: string; count: number }[] = [];
              for (const key in item) {
                  if (key !== "name" && key !== "Total" && key !== "uid" && key !== "teamUids" && key !== "Grand Total") {
                      budget.push({
                          budget: key,
                          count: item[key] || 0
                      });
                  }
              }
              return {
                  budget,
                  name: item.name,
                  total: item.Total
              };
          });
          
          // maindata=result
          // }else{
          //   maindata=reportData
          // }
      dispatcher(interestedBudgetReportData(result));}

    if(type==="location" ){
            // if(checked===true){
              // console.log("tableData",tableData)
              const result= tableData.map((item:any) => {
                const location: { location: string; count: number }[] = [];
                for (const key in item) {
                    if (key !== "name" && key !== "Total" && key !== "uid" && key !== "teamUids" && key !== "Grand Total") {
                        location.push({
                            location: key,
                            count: item[key] || 0
                        });
                    }
                }
                return {
                    location,
                    name: item.name,
                    total: item.Total
                };
            });
            
            // maindata=result
            // }else{
            //   maindata=reportData
            // }
      dispatcher(interestedLocationReportData(result));}

    if(type==="project" ){
              // if(checked===true){
                // console.log("tableData",tableData)
                const result= tableData.map((item:any) => {
                  const project: { project: string; count: number }[] = [];
                  for (const key in item) {
                      if (key !== "name" && key !== "Total" && key !== "uid" && key !== "teamUids" && key !== "Grand Total") {
                          project.push({
                              project: key,
                              count: item[key] || 0
                          });
                      }
                  }
                  return {
                      project,
                      name: item.name,
                      total: item.Total
                  };
              });
              
              // maindata=result
              // }else{
              //   maindata=reportData
              // }
      dispatcher(interestedProjectReportData(result));}

    if(type==="propertyType" ){
                // if(checked===true){
                  // console.log("tableData",tableData)
                  const result= tableData.map((item:any) => {
                    const property_type: { property_type: string; count: number }[] = [];
                    for (const key in item) {
                        if (key !== "name" && key !== "Total" && key !== "uid" && key !== "teamUids" && key !== "Grand Total") {
                            property_type.push({
                                property_type: key,
                                count: item[key] || 0
                            });
                        }
                    }
                    return {
                        property_type,
                        name: item.name,
                        total: item.Total
                    };
                });
                
                // maindata=result
                // }else{
                //   maindata=reportData
                // }
      dispatcher(interestedPropertyTypeReportData(result));}

    if(type==="propertyStage" ){
                  // if(checked===true){
                    // console.log("tableData",tableData)
                    const result= tableData.map((item:any) => {
                      const property_stage: { property_stage: string; count: number }[] = [];
                      for (const key in item) {
                          if (key !== "name" && key !== "Total" && key !== "uid" && key !== "teamUids" && key !== "Grand Total") {
                              property_stage.push({
                                  property_stage: key,
                                  count: item[key] || 0
                              });
                          }
                      }
                      return {
                          property_stage,
                          name: item.name,
                          total: item.Total
                      };
                  });
                  
                  // maindata=result
                  // }else{
                  //   maindata=reportData
                  // }
      dispatcher(interestedPropertyStageReportData(result));}

    if(type==="lost_reason" ){
                    // if(checked===true){
                      // console.log("tableData",tableData)
                      const result= tableData.map((item:any) => {
                        const lost_reason: { lost_reason: string; count: number }[] = [];
                        for (const key in item) {
                            if (key !== "name" && key !== "Total" && key !== "uid" && key !== "teamUids" && key !== "Grand Total") {
                                lost_reason.push({
                                    lost_reason: key,
                                    count: item[key] || 0
                                });
                            }
                        }
                        return {
                            lost_reason,
                            name: item.name,
                            total: item.Total
                        };
                    });
                    
                    // maindata=result
                    // }else{
                    //   maindata=reportData
                    // }
      dispatcher(lostReasonReportData(result));}

    if(type==="not_int_reason" ){
                      // if(checked===true){
                        // console.log("tableData",tableData)
                        const result= tableData.map((item:any) => {
                          const not_int_reason: { not_int_reason: string; count: number }[] = [];
                          for (const key in item) {
                              if (key !== "name" && key !== "Total" && key !== "uid" && key !== "teamUids" && key !== "Grand Total") {
                                  not_int_reason.push({
                                      not_int_reason: key,
                                      count: item[key] || 0
                                  });
                              }
                          }
                          return {
                              not_int_reason,
                              name: item.name,
                              total: item.Total
                          };
                      });
                      
                      // maindata=result
                      // }else{
                      //   maindata=reportData
                      // }
      dispatcher(notInterestedReportData(result));}

      if(type==="callLogs" ){
        // if(checked===true){
          // console.log("tableData",tableData)
          const result= tableData.map((item:any) => {
            const duration: { duration: string | number; count: number }[] = [];
            for (const key in item) {
                if (key !== "name" && key !== "Total" && key !== "uid" && key !== "teamUids" && key !== "Grand Total") {
                  // const durationValue: string | number = key === ">120 sec" ? "Other" : key;
                  let durationValue : string | number
                  if(key==="0 sec"){
                    durationValue = 0
                  }else if(key==="0-30 sec"){
                    durationValue = 30
                  }else if(key==="31-60 sec"){
                    durationValue = 60
                  }else if(key==="61-120 sec"){
                    durationValue = 120
                  }else{
                    durationValue = "Other"
                  }
                  // ">120 sec" ? "Other":"0 sec"?0:"0-30 sec"?30:"31-60 sec"?60:120 
                  // console.log("durationValueeeeeeeeeeeeeeeeeeee",durationValue)
                    duration.push({
                        duration: durationValue,
                        count: item[key] || 0
                    });
                }
            }
            return {
                duration,
                name: item.name,
                total: item.Total
            };
        });
        let newResult:any = {
          report:result
        }
        // maindata=result
        // }else{
        //   maindata=reportData
        // }
dispatcher(callBackReportData(newResult));}
        
  }, [tableData,checked,type]);

  return (
    <>
      {/* <h6 className={styles.heading}>
        {heading}
      </h6> */}
      <div className={styles.detailsBox} style={style} >
        {/* {type==="callLogs" ?<p className={styles.graphHeading}>{heading}</p>:null} */}
        <Table striped bordered hover>
          <thead>
            <tr>
              <th
                style={{ width: "auto", textAlign: "center", ...tableTextStyles }}
              >
                S.No
              </th>
              {header.map((item, index) => (
                <>
                  <th
                    style={{textAlign: item === 'Associate' ? 'left' : 'center', ...tableTextStyles }}
                  >
                    <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>{properFormat(item==="Associate"?"Team":item)} {item !=="Associate" && ( sortTable ?<ExpandLessIcon style={{ cursor: "pointer" }} onClick={() => handleSortTableData(item)} /> : <> <KeyboardArrowDownIcon style={{ cursor: "pointer" }} onClick={() => sortFunction(item)} /></>)}</div>
                    {/* <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>{properFormat(item)}</div> */}
                  </th>
                </>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => (
              <>
                <tr key={index} style={{ backgroundColor: index === 0 ? "rgb(39, 159, 159)" : '' }} >
                  <th style={{ width: "auto", textAlign: "center", ...tableTextStyles }}>{index > 0 ? <>{index}</> : null}</th>
                  <th
                    style={{
                      fontSize: '0.8rem',
                      fontWeight: 'bold',
                      color: index === 0 ? "white" : theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
                    }}
                  >
                    {properFormat(item.name)}
                  </th>
                  {header.slice(1).map((key: string, sIndex) => (
                    <>
                      <th
                        key={String(index) + String(sIndex)}
                        style={{
                          fontSize: '0.8rem',
                          cursor: item[key] ? 'pointer' : 'not-allowed',
                          textAlign: 'center',
                          fontWeight: index === 0 ? "bold" : 'normal',
                          color: index === 0 ? "white" : theme ? themeColors.textPrimary : themeColors.textPrimaryDark
                        }}
                        onClick={() => {
                          item[key] && getDrillDownData(key, item);
                        }}
                      >
                        {item[key] ? properFormat(item[key]) : 0}
                      </th>
                    </>
                  ))}
                </tr>
              </>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    user: state.user.data,
    teamLeadUsers: state.teamLeadUsers.data,
    branchUsers: state.branchUsers.data,
    theme: state.theme.isLightMode
  };
};
export default connect(mapStateToProps)(IntBarTable);
